import { useEffect } from 'react';

/**
 * Вызывает callback, когда страница восстановлена из back/forward cache.
 */
export const useOnPageRestoreFromBFCache = (callback: () => void) => {
  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        callback();
      }
    };

    window.addEventListener('pageshow', onPageShow);

    return () => {
      window.removeEventListener('pageshow', onPageShow);
    };
  }, [callback]);
};
